import React, { Component } from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { connect } from 'react-redux'
import Col from "antd/lib/col";

import { ClassType } from "../core/FormScheme";
import { selectItem } from "./actions";
import { selectedItem } from "./reducers";


const style: React.CSSProperties = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
}

const selectedStyle: React.CSSProperties = {
    position: 'relative',
    border: '1px solid #90d8c8 !important',
    background: '#e1fffe'
}

export class FormItemComponent extends Component<{
    class: ClassType,
    [key: string]: any
}> {
    myRef: any;
    constructor(props) {
        super(props)
        this.state = {

        }
        this.myRef = React.createRef();
    }

    render() {
        const { isDragging, connectDragSource, connectDropTarget } = this.props
        const opacity = isDragging ? 0 : 1
        let containerStyle = { ...style, opacity }

        const TagName: any = this.props.class.componentObject

        if (this.props.isActiveItem) {
            Object.assign(containerStyle, selectedStyle)
        }
        return (
            <Col span={this.props.span || 6} style={containerStyle} onClick={() => this.props.onItemClick(this.props.item, this.props.formKey)}>
                {connectDropTarget(connectDragSource(
                    <div>
                        <TagName form={this.props.form} field={this.props.field} formLayout={this.props.formLayout} {...this.props}></TagName>
                    </div>
                ))}
            </Col>
        )

    }
}
let hoveredItem
const WfComponentTarget = {
    drop(props, monitor) {
        const item = monitor.getItem();
        // console.log("item", item)
        if (item && item.index != undefined) {
            // hoveredItem = null
            const dragIndex = item.index
            const hoverIndex = props.index;

            let dragFormKey = item.id
            let hoverFormKey = props.formKey

            // Don't replace items with themselves
            if (dragFormKey === hoverFormKey) {
                return;
            }

            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex, dragFormKey, hoverFormKey);

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        } else {
            const hoverIndex = props.index;
            props.addField(item, hoverIndex)
        }
    },
    hover(props, monitor, component) {
        // const item = monitor.getItem();
        // console.log("hover item", item)
        // console.log("hoveredItem", hoveredItem)
        // if (!hoveredItem && item && item.index != undefined) {
        //     const dragIndex = item.index
        //     const hoverIndex = props.index;

        //     let dragFormKey = item.id
        //     let hoverFormKey = props.formKey
        //     // Don't hover back again
        //     hoveredItem = hoverFormKey
        //     // Don't replace items with themselves
        //     if (dragFormKey === hoverFormKey) {
        //         return;
        //     }

        //     // Time to actually perform the action
        //     props.moveField(dragIndex, hoverIndex, dragFormKey, hoverFormKey);

        //     // Note: we're mutating the monitor item here!
        //     // Generally it's better to avoid mutations,
        //     // but it's good here for the sake of performance
        //     // to avoid expensive index searches.
        //     monitor.getItem().index = hoverIndex;
        //     console.log("draged", hoveredItem)
        // }
    }
};
const WfComponentDropConnect = (connect, monitor, props) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
})

const WfComponentSource = {
    beginDrag(props) {
        // Return the data describing the dragged item
        const item = {
            id: props.formKey,
            index: props.index,
            item: props.item
        }
        return item
    },

    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return
        }

        // When dropped on a compatible target, do something
        const item = monitor.getItem()
        const dropResult = monitor.getDropResult()
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
}

/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    }
}

const FormItemDragComponent = DropTarget(["field", "component"], WfComponentTarget, WfComponentDropConnect)(DragSource("field", WfComponentSource, collect)(FormItemComponent))

const mapStateToProps = (state, ownProps) => {
    return {
        isActiveItem: ownProps.item === state.selectedItem
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onItemClick: (item, formKey) => dispatch(selectItem(item, formKey))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormItemDragComponent)